import {
	Table,
	TableContainer,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import React from 'react';

interface Columns {
	key: string;
	title: string;
	render?: (value: any) => React.ReactNode;
	align?: 'start' | 'end' | 'center';
	isNumeric?: boolean;
}

const TableUI = ({
	dataTable,
	columns,
}: {
	dataTable: any;
	columns: Columns[];
}) => {
	return (
		<TableContainer>
			<Table variant={'simple'} colorScheme={'blackAlpha'}>
				<Thead>
					<Tr>
						{columns.map((col) => (
							<Th
								color={'#737283'}
								textTransform={'capitalize'}
								key={col.key}
								py={'32px'}
								isNumeric={col.isNumeric}
							>
								{col.title}
							</Th>
						))}
					</Tr>
				</Thead>
				<Tbody>
					{dataTable.length > 0 &&
						dataTable.map((data: any) => (
							<Tr key={data.key}>
								{columns.map((col) => (
									<Td key={col.key} isNumeric={col.isNumeric}>
										{col.render ? col.render(data[col.key]) : data[col.key]}
									</Td>
								))}
							</Tr>
						))}
				</Tbody>
			</Table>
		</TableContainer>
	);
};

export default TableUI;
